// extracted by mini-css-extract-plugin
module.exports = {"confirm":"Confirm_confirm__1Ytlq","confirmContent":"Confirm_confirmContent__m1AK_","confirmContentCta":"Confirm_confirmContentCta__x7JN4"};